import {Component, Input, OnInit} from '@angular/core';

@Component({
    selector: 'app-student-statistic',
    templateUrl: './student-statistic.component.html',
    styleUrls: ['./student-statistic.component.scss'],
})
export class StudentStatisticComponent implements OnInit {
    @Input() newExam: number | undefined = undefined;
    @Input() withoutProgress: boolean = false;
    @Input() typeGroup: string = '';

    constructor() {
    }

    ngOnInit() {
    }


}
